<app-sidebar class="nav-sidebar__sidebar" [items]="items" [selectedPrimary]="mainSelected" [selectedSecondary]="secondarySelected"
  (api)="onApi($event)" (itemClick)="onItemClick($event)">
  <ng-content></ng-content>
</app-sidebar>
